import { Site } from '@envato/foundation-types'
import * as React from 'react'

import DefaultItemCard from './defaultItemCard'
import GraphicRiverItemCard from './graphicRiverItemCard'
import PhotoduneGridItemCard from './photoduneGridItemCard/photoduneItemCardContainer'

import { IProps } from './itemCardContainer'

const ItemCard = ({ currentSite, ...props }: IProps): any => {
  if (currentSite === Site.photodune) {
    return <PhotoduneGridItemCard {...props} />
  } else if (currentSite === Site.graphicriver) {
    return <GraphicRiverItemCard {...props} />
  }

  return <DefaultItemCard {...props} />
}

export default ItemCard
